import React from "react";
import styles from "./LoginLayout.module.scss";
import Logo from "../../../assets/logo";
import BGColor from "../../../assets/background_color.svg";
import BorneImg from "../../../assets/borne-top-3-4.png";

export interface LoginLayoutProps {
  children?: React.ReactNode;
  centered?: boolean;
}

/**
 * Layout for login page
 * @param param0
 * @returns
 */
export default function LoginLayout({ children, centered }: LoginLayoutProps) {
  const centeredTag = centered ?"--centered" : "";
  return (
    <div className={styles["global-container"]}>
      <img className={styles["background"]} src={BGColor} alt="background" />
      <div className={styles["layout-global"]}>
        <div className={styles["header"]}>
          <div className={styles["header-logo"]}>
            <Logo />
          </div>
        </div>
        <div className={styles["content"]}>
          <div
            className={[
              styles["container-item"],
              styles["container-item--left"],
              styles["container-item--borne"],
              styles["container-item--left"+centeredTag],

            ].join(" ")}
          >
            <img className={styles["img-borne"]} src={BorneImg} alt="borne" />
          </div>
          <div
            className={[
              styles["container-item"],
              styles["container-item--right"],
              styles["container-item--right"+centeredTag],
            ].join(" ")}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
